// extracted by mini-css-extract-plugin
export var content = "Intro-module--content--6bb18";
export var contentLayout = "Intro-module--contentLayout--58b10";
export var fadeInAnimation = "Intro-module--fadeInAnimation--8ad68";
export var intro = "Intro-module--intro--eba7a";
export var mobileHidden = "Intro-module--mobileHidden--c73ea";
export var picture = "Intro-module--picture--7d7d6";
export var pictureImage = "Intro-module--pictureImage--7be33";
export var wrap = "Intro-module--wrap--04811";